(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/team-invite-link.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/team-invite-link.js');
'use strict';

const Button = svs.ui.ReactButton;
const IconText = svs.tb_ui_react.icon_text.IconText;
const MAX_MEMBERS = svs.arena.constants.MAX_MEMBERS;
const TeamShowLink = svs.arena.pages.teams.components.TeamShowLink;
const createTeamInviteId = svs.arena.store.teams.actions.createTeamInviteId;
const showCreateNewInviteLinkSuccess = svs.arena.pages.teams.dialogs.showCreateNewInviteLinkSuccess;
const TeamInviteLink = _ref => {
  let fullMemberCount = _ref.fullMemberCount,
    isExpanded = _ref.isExpanded,
    teamId = _ref.teamId;
  const dispatch = ReactRedux.useDispatch();
  const inviteIds = ReactRedux.useSelector(state => {
    var _state$teams;
    return (_state$teams = state.teams) === null || _state$teams === void 0 ? void 0 : _state$teams.inviteIds;
  }) || [];
  const linkId = inviteIds.find(item => item.teamId === teamId);
  svs.arena.logger.debug('TeamInviteLink, linkId', linkId);
  const createNewLink = async () => {
    var _linkData$payload;
    svs.arena.logger.debug('TeamInviteLink, createNewLink, teamId:', teamId);
    const linkData = await dispatch(createTeamInviteId({
      teamId
    }));
    svs.arena.logger.debug('TeamInviteLink, createdNewLink, linkData:', linkData);
    const validUntil = linkData === null || linkData === void 0 || (_linkData$payload = linkData.payload) === null || _linkData$payload === void 0 || (_linkData$payload = _linkData$payload.data) === null || _linkData$payload === void 0 ? void 0 : _linkData$payload.validUntil;
    svs.arena.logger.debug('TeamInviteLink, createdNewLink, linkData validUntil:', validUntil);
    const track = {
      category: 'spela-tillsammans',
      action: 'invite_members',
      opt_label: 'generate_new_link'
    };
    svs.components.analytics.trackEvent(track);
    showCreateNewInviteLinkSuccess(validUntil);
  };
  return React.createElement(React.Fragment, null, React.createElement("h4", {
    className: "h4 margin-top-2 margin-bottom-1"
  }, React.createElement("span", {
    className: "f-medium"
  }, " Bjud in medlemmar ")), React.createElement("p", {
    className: "f-content"
  }, "Skicka inbjudan till de personer du vill bjuda in till ditt lag genom att kopiera och dela l\xE4nken eller skicka inbjudan via sms eller mail."), fullMemberCount >= MAX_MEMBERS && React.createElement(IconText, {
    className: "margin-left-1 margin-bottom-1"
  }, "Laget har maximalt antal medlemmar"), linkId && React.createElement(React.Fragment, null, React.createElement(TeamShowLink, {
    isExpanded: isExpanded,
    teamId: teamId
  }), React.createElement("p", {
    className: "f-content margin-top-1"
  }, "Om du beh\xF6ver kan du skapa en ny l\xE4nk, d\xE5 blir den f\xF6rra l\xE4nken ogiltig.")), React.createElement(Button, {
    block: true,
    className: "margin-top-1",
    onClick: createNewLink,
    size: 300,
    transparent: true
  }, linkId ? 'Byt ut länken' : 'Skapa ny länk'));
};
svs.arena.pages.teams.components.TeamInviteLink = TeamInviteLink;

 })(window);